import {Button, Card, CardActions, CardContent, CardHeader, Grid, List, ListItem, ListItemText} from '@mui/material';
import {PriceInterval, Product} from '../../../__generated__/resolvers-types';
import {DEFAULT_STRIPE_ROLE} from '../../../constants';
import {formatCurrency} from '../../../util/formatCurrency';

export interface SubscriptionOptionCardProps {
  product: Product;
  isMonthly: boolean;
  handleSubscribe: (priceId: string) => void;
}

export default function SubscriptionOptionCard({product, isMonthly, handleSubscribe}: SubscriptionOptionCardProps) {
  const price = product.prices.find((p) => p.interval === (isMonthly ? PriceInterval.month : PriceInterval.year));

  if (!price) {
    return null;
  }

  return (
    <Grid key={price.id}>
      <Card sx={{height: '100%', display: 'flex', flexDirection: 'column'}}>
        <CardHeader
          title={product.name}
          subheader={`${formatCurrency(price.currency, price.unitAmount / 100)} ${isMonthly ? 'per month' : 'per year'}`}
        />
        <CardContent>
          <List>
            {product.features.map((feature, index) => (
              <ListItem key={feature} divider={index !== product.features.length - 1}>
                <ListItemText primary={feature} />
              </ListItem>
            ))}
          </List>
        </CardContent>
        <CardActions sx={{mt: 'auto', pt: 2}}>
          {product.role === DEFAULT_STRIPE_ROLE ? (
            <Button variant="contained" color="primary" disabled fullWidth>
              Current Plan
            </Button>
          ) : (
            <Button variant="contained" color="primary" onClick={() => handleSubscribe(price.id)} fullWidth>
              Subscribe
            </Button>
          )}
        </CardActions>
      </Card>
    </Grid>
  );
}
